import { useMediaQuery as mq } from "react-responsive";

const useMediaQuery = () => {
  const isDesktop = mq({ minDeviceWidth: 600 });

  return { isDesktop };
};

export default useMediaQuery;
